module.exports = "<md-chip-list>\r\n  <md-chip *ngFor=\"let chip of chipsList; let i = index\" style=\"padding: 7px 7px 7px 12px;\">\r\n    <span>{{chip.Label}}</span>\r\n    <i (click)=\"removeFilter(chip, i)\" class=\"zmdi zmdi-close\"></i>\r\n  </md-chip>\r\n</md-chip-list>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/chip-filter-list/chip-filter-list.component.html
// module id = ../../../../../src/app/components/common/chip-filter-list/chip-filter-list.component.html
// module chunks = 0